import { useQuery } from '@apollo/client';
import AttachMoney from '@mui/icons-material/AttachMoney';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassBottom from '@mui/icons-material/HourglassBottom';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SiiIcon from '../components/icons/SiiIcon';
import { REQUESTING_PLATFORM_TO_ICON } from '../constants/requesting-platform';
import { GET_REQUESTING_PLATFORMS } from '../graphql';
import { SECONDARY_ICON_CLASS_NAME } from '../theme/constants/icon';

const quickButtons = () => {
  const arraysEqual = (a, b) => {
    const setA = new Set(a);
    const setB = new Set(b);
    return setA.size === setB.size
      && [...setA].every((x) => setB.has(x));
  };
  const buttons = [
    {
      id: 'rejected',
      key: 'siiStatus',
      title: 'Rechazadas',
      mobileTitle: 'Rechazadas',
      value: ['Rejected'],
      EndIcon: SiiIcon,
      color: 'red',
      defaultValue: [],
      getIsActive: (actualStates) => actualStates.siiStatus?.includes('Rejected'),
    },
    {
      id: 'payed',
      key: 'documentFinanceStatus',
      title: 'Pagadas',
      mobileTitle: 'Pagadas',
      value: ['6', '7'],
      EndIcon: AttachMoney,
      color: 'green',
      defaultValue: [],
      getIsActive: (actualStates) => arraysEqual(actualStates.documentFinanceStatus, ['6', '7']),
    },
    {
      id: 'evaluationPendingDocuments',
      key: 'preoffer_Preofferevaluationrequest_Status',
      title: 'Requiere documentos',
      mobileTitle: 'Requiere documentos',
      value: 'PendingDocuments',
      EndIcon: HourglassBottom,
      className: SECONDARY_ICON_CLASS_NAME,
      defaultValue: null,
      getIsActive: (actualStates) => actualStates.preoffer_Preofferevaluationrequest_Status === 'PendingDocuments',
    },
    {
      id: 'evaluationRejected',
      key: 'preoffer_Preofferevaluationrequest_Status',
      title: 'No Financiable',
      mobileTitle: 'No Financiable',
      value: 'Rejected',
      EndIcon: CancelIcon,
      className: SECONDARY_ICON_CLASS_NAME,
      defaultValue: null,
      getIsActive: (actualStates) => actualStates.preoffer_Preofferevaluationrequest_Status === 'Rejected',
    },
    {
      id: 'evaluationInProcess',
      key: 'preoffer_Preofferevaluationrequest_Status',
      title: 'Evaluando',
      mobileTitle: 'Evaluando',
      value: 'Evaluating',
      EndIcon: PsychologyIcon,
      className: SECONDARY_ICON_CLASS_NAME,
      defaultValue: null,
      getIsActive: (actualStates) => actualStates.preoffer_Preofferevaluationrequest_Status === 'Evaluating',
    },
  ];

  return buttons;
};

const useQuickFilterButtons = () => {
  const { data: requestingPlatforms } = useQuery(GET_REQUESTING_PLATFORMS);
  const platforms = requestingPlatforms?.getRequestingPlatforms || [];
  const selectableButtons = quickButtons();
  platforms.forEach((platform) => {
    const PlatformIcon = REQUESTING_PLATFORM_TO_ICON[platform.code];
    if (PlatformIcon) {
      selectableButtons.push(
        {
          id: `requestingPlatform_${platform.code}`,
          key: 'operation_RequestingPlatform_Code',
          title: platform.code,
          mobileTitle: platform.code,
          value: platform.code,
          EndIcon: PlatformIcon,
          color: 'info',
          defaultValue: null,
          getIsActive: (
            actualStates,
          ) => actualStates.operation_RequestingPlatform_Code === platform.code,
        },
      );
    }
  });

  return selectableButtons;
};

export default useQuickFilterButtons;
